import { useNavigate } from "@tanstack/react-router";
import { HelpCircle } from "lucide-react";

type HelpFABProps = {
  token: string;
};

export function HelpFAB({ token }: HelpFABProps) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      aria-label="How it works"
      onClick={() => navigate({ to: "/mapping/$token/help", params: { token } })}
      className="fixed bottom-6 right-4 z-40 flex size-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-transform hover:scale-105 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <HelpCircle size={22} aria-hidden="true" />
    </button>
  );
}
